import { constants } from "../constant/constants";
import { HttpHelper } from "../helper/http-helper-service";
import { TicketPaginationValues } from "../model/ticket/ticket-pagination-values";

export default class ticketApiService {
  static GetAllTickets(pagination: TicketPaginationValues) {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getAllTickets,
      pagination,
    );
  }

  static getTicketDetailByIdForSignalR(...params: any[]): Promise<any> {
    if (params[0] != null && params[1] != null) {
      return HttpHelper.getData(
        constants.apiUrl.ticketUrls.getTicketDetailById +
          "?TicketId=" +
          params[0] +
          "&signalRMessageTick=" +
          params[1],
      );
    } else {
      return HttpHelper.getData(
        constants.apiUrl.ticketUrls.getTicketDetailById +
          "?TicketId=" +
          params[0].ticketId +
          "&signalRMessageTick=" +
          params[0].tick,
      );
    }
  }

  static getTicketComments = (id: string, params: object) => {
    let url = constants.apiUrl.ticketUrls.getTicketComments;
    return HttpHelper.postData(url, params);
  };

  static getCommentByCommentId = (id: string, ticketId: string) => {
    return HttpHelper.getData(
      constants.apiUrl.ticketUrls.getCosmosCommentByCommentId +
        "/" +
        id +
        "/" +
        ticketId,
    );
  };

  static getCommentListByTick = (object: any) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getCommentListByTick,
      object,
    );
  };

  static async getTicketsByTick(tick: number) {
    return HttpHelper.getData(
      constants.apiUrl.ticketUrls.ticketbytick + "?storeTick=" + tick,
    );
  }

  static getTicketCosmosCommentById = (id: number, params: object) => {
    let url = constants.apiUrl.ticketUrls.getTicketCosmosCommentById + "/" + id;
    return HttpHelper.getData(url, params);
  };

  static saveTicketComment(dataModel: any) {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.saveTicketComment,
      dataModel,
    );
  }

  static createEncryptedTextLink = (params: object) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.createEncryptedTextLink,
      params,
    );
  };

  static getCommentListByFilter = (object: any) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getCommentListByFilter,
      object,
    );
  };

  static updateTicketComment(dataModel: any) {
    return HttpHelper.patchData(
      constants.apiUrl.ticketUrls.updateTicketComment,
      dataModel,
    );
  }

  static getCommentsByCommentIds = (object: any) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getCommentsByCommentIds,
      object,
    );
  };

  static getBlobSharedAccessSignature = (params: object) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getBlobSharedAccessSignature,
      params,
    );
  };

  static setCommentReaction = (params: object) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.setCommentReaction,
      params,
    );
  };

  static UpdateTicketContacts(object: any) {
    const url = constants.apiUrl.ticketUrls.updateticketcontact;
    return HttpHelper.patchData(url, object);
  }

  static setCommentCCEmail = (params: object) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.setCommentCCEmail,
      params,
    );
  };

  static getTicketTypeList = () => {
    return HttpHelper.getData(constants.apiUrl.ticketUrls.getTicketTypeList);
  };

  static getTicketTagsList = () => {
    return HttpHelper.getData(constants.apiUrl.ticketUrls.getTicketTagsList);
  };
}
